import { render, staticRenderFns } from "./MainPageTitle.vue?vue&type=template&id=79267bf7&scoped=true&"
import script from "./MainPageTitle.vue?vue&type=script&lang=js&"
export * from "./MainPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79267bf7",
  null
  
)

export default component.exports